import { render, staticRenderFns } from "./JimunSvg.vue?vue&type=template&id=b9e9b93c&scoped=true&"
import script from "./JimunSvg.vue?vue&type=script&lang=js&"
export * from "./JimunSvg.vue?vue&type=script&lang=js&"
import style0 from "./JimunSvg.vue?vue&type=style&index=0&id=b9e9b93c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9e9b93c",
  null
  
)

export default component.exports